(function () {
  var ROOT_SELECTOR = '[data-td-funda-builder]';
  var CONFIG_SELECTOR = '[data-td-funda-config]';

  var PIECE_ORDER = ['seat', 'back', 'chaise'];

var PIECE_COPY = {
  seat: {
    title: 'Funda de asiento',
    help: '1 funda cubre 1 cojín de asiento.',
    benefits: [
      'Ajuste elástico para calce perfecto.',
      'Se instala sin desmontar el cojín.',
      'Impermeable y resistente a garras y pelos.'
    ],
    image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/seat-cover-3-body.svg?v=1781944623'
  },

  back: {
    title: 'Funda de respaldo',
    help: '1 funda cubre 1 cojín de respaldo.',
    benefits: [
      'Ajuste elástico para calce perfecto.',
      'Se instala sin desmontar el cojín.',
      'Impermeable y resistente a garras y pelos.'
    ],
    image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/back-cover-3-body.svg?v=1781944622'
  },

  chaise: {
    title: 'Funda para chaise / lateral en L',
    help: 'Sirve para lateral izquierdo o derecho.',
    benefits: [
      'Compatible con lado izquierdo o derecho.',
      'Se instala sin desmontar el cojín.',
      'Impermeable y resistente a garras y pelos.'
    ],
    image: 'https://cdn.shopify.com/s/files/1/0698/1687/7356/files/chaise-cover-3-body.svg?v=1781944622'
  }
};

  var SWATCHES = {
    'gris claro': '#d4d1ca',
    'gris oscuro': '#595959',
    'gris': '#9a9994',
    'caqui': '#b6a47f',
    'khaki': '#b6a47f',
    'crema': '#efe2cf',
    'beige': '#d9c6aa',
    'blanco': '#f8f6ef',
    'white': '#f8f6ef',
    'cafe oscuro': '#4e3328',
    'café oscuro': '#4e3328',
    'cafe': '#6a4635',
    'café': '#6a4635',
    'marron': '#6a4635',
    'marrón': '#6a4635',
    'negro': '#111111',
    'black': '#111111',
    'azul': '#365a7a',
    'verde': '#66745d',
    'rojo': '#8d2f2f'
  };

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[char];
    });
  }

  function unique(values) {
    var seen = {};
    var output = [];

    values.forEach(function (value) {
      var key = normalize(value);
      if (!key || seen[key]) return;
      seen[key] = true;
      output.push(value);
    });

    return output;
  }

  function variantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;

    return [variant.option1, variant.option2, variant.option3].filter(function (option) {
      return option != null;
    });
  }

  function optionValue(variant, optionIndex) {
    var options = variantOptions(variant);
    return options[optionIndex] || '';
  }

  function money(cents, currency) {
    var safeCents = Number(cents || 0);
    var isoCurrency = currency || 'CLP';

    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: isoCurrency,
        maximumFractionDigits: 0
      }).format(safeCents / 100);
    } catch (error) {
      return '$' + Math.round(safeCents / 100).toLocaleString('es-CL');
    }
  }

  function findOptionIndex(options, patterns) {
    var normalizedPatterns = patterns.map(normalize);

    for (var i = 0; i < options.length; i += 1) {
      var optionName = normalize(options[i]);

      for (var j = 0; j < normalizedPatterns.length; j += 1) {
        if (optionName.indexOf(normalizedPatterns[j]) !== -1) {
          return i;
        }
      }
    }

    return -1;
  }

  function getColorHex(colorName) {
    var key = normalize(colorName);
    return SWATCHES[key] || '#ded8ce';
  }

  function getPieceKey(value) {
    var text = normalize(value);

    if (!text) return '';
    if (text.indexOf('chaise') !== -1 || text.indexOf('lateral') !== -1 || text.indexOf('seccional') !== -1 || /\ben l\b/.test(text)) return 'chaise';
    if (text.indexOf('respaldo') !== -1 || text.indexOf('back') !== -1) return 'back';
    if (text.indexOf('asiento') !== -1 || text.indexOf('seat') !== -1) return 'seat';

    return text.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'pieza';
  }

  function getPieceTitle(pieceKey, fallback) {
    return (PIECE_COPY[pieceKey] && PIECE_COPY[pieceKey].title) || fallback || 'Funda';
  }

  function getPieceHelp(pieceKey) {
    return (PIECE_COPY[pieceKey] && PIECE_COPY[pieceKey].help) || 'Elige cuántas fundas quieres agregar.';
  }

 function getPieceIcon(pieceKey) {
  var piece = PIECE_COPY[pieceKey] || {};

  if (!piece.image) return '';

  return '' +
    '<img class="td-funda-builder__icon" ' +
      'src="' + escapeHtml(piece.image) + '" ' +
      'alt="" ' +
      'width="96" ' +
      'height="72" ' +
      'loading="lazy" ' +
      'decoding="async">';
}

  function parsePackQuantity(value) {
    var text = normalize(value);
    var match = text.match(/(\d+)\s*fundas?/);
    if (match) return Math.max(parseInt(match[1], 10) || 1, 1);

    match = text.match(/(\d+)/);
    if (match) return Math.max(parseInt(match[1], 10) || 1, 1);

    return 1;
  }

  function looksLikeUnitMode(optionName, values) {
    var name = normalize(optionName);

    if (name.indexOf('pieza') !== -1 || name.indexOf('tipo') !== -1 || name.indexOf('cover type') !== -1) return true;

    return values.every(function (value) {
      var text = normalize(value);
      var simplePiece = ['asiento', 'seat', 'respaldo', 'back', 'chaise', 'lateral', 'seccional'].some(function (token) {
        return text === token || text === 'funda de ' + token || text === 'funda ' + token;
      });

      return simplePiece || (text.indexOf('funda') !== -1 && !/\d/.test(text) && text.length <= 28);
    });
  }

  function getFirstAvailableColor(model) {
    if (!model.valid || !model.colors.length) return '';

    for (var i = 0; i < model.colors.length; i += 1) {
      var color = model.colors[i];
      var hasAvailableVariant = model.variants.some(function (variant) {
        return variant.available && normalize(optionValue(variant, model.colorIndex)) === normalize(color);
      });

      if (hasAvailableVariant) return color;
    }

    return model.colors[0];
  }

  function buildModel(config) {
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var options = Array.isArray(config.options) ? config.options : [];
    var colorIndex = findOptionIndex(options, ['color', 'colour']);
    var sizeIndex = findOptionIndex(options, ['talla', 'size', 'medida', 'tamano', 'tamaño']);
    var coverIndex = findOptionIndex(options, ['pieza', 'cojin', 'cojines', 'funda', 'cover', 'tipo']);

    if (coverIndex === -1) {
      for (var i = 0; i < options.length; i += 1) {
        if (i !== colorIndex && i !== sizeIndex) {
          coverIndex = i;
          break;
        }
      }
    }

    if (coverIndex === -1 || colorIndex === -1) {
      return {
        valid: false,
        reason: 'Para activar este selector, el producto debe tener una opción de fundas/piezas y una opción de color.'
      };
    }

    var coverValues = unique(variants.map(function (variant) { return optionValue(variant, coverIndex); }));
    var colorValues = unique(variants.map(function (variant) { return optionValue(variant, colorIndex); }));
    var sizeValues = sizeIndex > -1 ? unique(variants.map(function (variant) { return optionValue(variant, sizeIndex); })) : [];
    var unitMode = looksLikeUnitMode(options[coverIndex], coverValues);

    var groups = {};

    variants.forEach(function (variant) {
      var coverValue = optionValue(variant, coverIndex);
      var pieceKey = getPieceKey(coverValue);
      var packQty = unitMode ? 1 : parsePackQuantity(coverValue);

      if (!pieceKey) return;

      if (!groups[pieceKey]) {
        groups[pieceKey] = {
          key: pieceKey,
          title: getPieceTitle(pieceKey, coverValue),
          help: getPieceHelp(pieceKey),
          values: {},
          quantities: [],
          firstCoverValue: coverValue
        };
      }

      if (!groups[pieceKey].values[packQty]) {
        groups[pieceKey].values[packQty] = coverValue;
        groups[pieceKey].quantities.push(packQty);
      }
    });

    var pieces = Object.keys(groups).map(function (key) {
      groups[key].quantities = groups[key].quantities.sort(function (a, b) { return a - b; });
      return groups[key];
    });

    pieces.sort(function (a, b) {
      var aIndex = PIECE_ORDER.indexOf(a.key);
      var bIndex = PIECE_ORDER.indexOf(b.key);
      if (aIndex === -1) aIndex = 99;
      if (bIndex === -1) bIndex = 99;
      return aIndex - bIndex || a.title.localeCompare(b.title);
    });

    return {
      valid: pieces.length > 0 && colorValues.length > 0,
      reason: pieces.length ? '' : 'No encontramos variantes de asiento, respaldo o chaise.',
      mode: unitMode ? 'unit' : 'pack',
      options: options,
      variants: variants,
      coverIndex: coverIndex,
      colorIndex: colorIndex,
      sizeIndex: sizeIndex,
      colors: colorValues,
      sizes: sizeValues,
      pieces: pieces,
      currency: config.currency || 'CLP'
    };
  }

  function makeBuilder(root, config) {
    var model = buildModel(config);
    var state = {};
    var defaultColor = model.valid && model.colors.length ? getFirstAvailableColor(model) : '';
    var messageEl = root.querySelector('[data-td-funda-message]');
    var cardsEl = root.querySelector('[data-td-funda-cards]');
    var colorsEl = root.querySelector('[data-td-funda-colors]');
    var colorWrapEl = root.querySelector('[data-td-funda-base-color-wrap]');
    var submitEl = root.querySelector('[data-td-funda-submit]');

    function setMessage(message, type) {
      if (!messageEl) return;

      messageEl.textContent = message || '';
      messageEl.classList.toggle('is-error', type === 'error');
    }

    function getRoutes() {
      return window.routes || {
        cart_add_url: (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js',
        cart_url: (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'
      };
    }

    function findVariant(piece, selected) {
      var coverValue = model.mode === 'unit'
        ? piece.firstCoverValue
        : piece.values[selected.qty];
      var selectedSize = selected.size || '';

      return model.variants.find(function (variant) {
        if (!variant.available) return false;
        if (normalize(optionValue(variant, model.coverIndex)) !== normalize(coverValue)) return false;
        if (normalize(optionValue(variant, model.colorIndex)) !== normalize(selected.color)) return false;
        if (model.sizeIndex > -1 && selectedSize && normalize(optionValue(variant, model.sizeIndex)) !== normalize(selectedSize)) return false;
        return true;
      });
    }

    function getAvailableQuantities(piece, color, size) {
      if (model.mode === 'unit') return [1];

      return piece.quantities.filter(function (qty) {
        var selected = {
          color: color,
          size: size || '',
          qty: qty
        };
        return !!findVariant(piece, selected);
      });
    }

    function getAvailableSizes(piece, color) {
      if (model.sizeIndex === -1) return [];

      return model.sizes.filter(function (size) {
        if (model.mode === 'unit') {
          return !!findVariant(piece, { color: color, size: size, qty: 1 });
        }

        return piece.quantities.some(function (qty) {
          return !!findVariant(piece, { color: color, size: size, qty: qty });
        });
      });
    }

    function getDefaultSize(piece, color) {
      var sizes = getAvailableSizes(piece, color);
      return sizes.length ? sizes[0] : '';
    }

    function getInitialQty(piece, color, size) {
      if (model.mode === 'unit') return 1;
      var quantities = getAvailableQuantities(piece, color, size);
      return quantities.length ? quantities[0] : (piece.quantities[0] || 1);
    }

function getBestColorForPiece(piece, preferredColor) {
  return preferredColor || defaultColor || model.colors[0] || '';
}

    function getCardPrice(piece, selected) {
      var candidate = selected;

      if (!candidate) {
        var color = getBestColorForPiece(piece, defaultColor);
        var size = getDefaultSize(piece, color);
        var qty = getInitialQty(piece, color, size);
        candidate = { color: color, size: size, qty: qty };
      }

      var variant = findVariant(piece, candidate);
      if (!variant) return null;

      return {
        price: Number(variant.price || 0),
        compareAt: Number(variant.compare_at_price || 0),
        variant: variant,
        prefix: model.mode === 'pack' && !selected && piece.quantities.length > 1 ? 'desde' : ''
      };
    }

    function selectedLines() {
      var lines = [];

      for (var i = 0; i < model.pieces.length; i += 1) {
        var piece = model.pieces[i];
        var selected = state[piece.key];

        if (!selected || !selected.selected) continue;

        var variant = findVariant(piece, selected);
        if (!variant) {
          return {
            error: piece.title + ' en ' + selected.color + ' no está disponible.'
          };
        }

        var itemQty = model.mode === 'unit' ? selected.qty : 1;
        var units = selected.qty;

        lines.push({
          piece: piece,
          selected: selected,
          variant: variant,
          units: units,
          linePrice: Number(variant.price || 0) * itemQty,
          item: {
            id: Number(variant.id),
            quantity: itemQty,
            properties: {
              _td_selector: 'funda_magica_builder',
              _td_builder_mode: model.mode,
              _td_piece: piece.title,
              _td_color: selected.color,
              _td_units: String(units)
            }
          }
        });
      }

      return { lines: lines };
    }

    function renderColors() {
      if (!colorsEl || !colorWrapEl) return;

      if (!model.colors.length) {
        colorWrapEl.hidden = true;
        return;
      }

      colorWrapEl.hidden = false;

      colorsEl.innerHTML = model.colors.map(function (color) {
        var active = normalize(color) === normalize(defaultColor);
        return '' +
          '<button type="button" class="td-funda-builder__swatch ' + (active ? 'is-active' : '') + '" ' +
            'style="--td-swatch: ' + getColorHex(color) + '" ' +
            'data-td-funda-base-color="' + escapeHtml(color) + '" ' +
            'aria-pressed="' + (active ? 'true' : 'false') + '">' +
            escapeHtml(color) +
          '</button>';
      }).join('');
    }

    function renderPrice(priceInfo) {
      if (!priceInfo) return '<p class="td-funda-builder__price"><strong>Agotado</strong></p>';

      var html = '<p class="td-funda-builder__price">';
      if (priceInfo.prefix) {
        html += '<span class="td-funda-builder__price-prefix">' + priceInfo.prefix + '</span>';
      }
      if (priceInfo.compareAt && priceInfo.compareAt > priceInfo.price) {
        html += '<s>' + money(priceInfo.compareAt, model.currency) + '</s>';
      }
      html += '<strong>' + money(priceInfo.price, model.currency) + '</strong>';
      html += '</p>';
      return html;
    }
function renderBenefits(benefits) {
  if (!Array.isArray(benefits) || !benefits.length) {
    return '';
  }

  return (
    '<ul class="td-funda-builder__benefits" ' +
      'aria-label="Beneficios de esta funda">' +
      benefits.map(function (benefit) {
        return (
          '<li>' +
            escapeHtml(benefit) +
          '</li>'
        );
      }).join('') +
    '</ul>'
  );
}
    function renderSelectOptions(values, selectedValue) {
      return values.map(function (value) {
        return '<option value="' + escapeHtml(value) + '" ' + (normalize(value) === normalize(selectedValue) ? 'selected' : '') + '>' + escapeHtml(value) + '</option>';
      }).join('');
    }

    function renderCards() {
      if (!cardsEl) return;

      if (!model.valid) {
        cardsEl.innerHTML = '<div class="td-funda-builder__empty">' + escapeHtml(model.reason || 'No se pudo cargar el selector de fundas.') + '</div>';
        if (submitEl) {
          submitEl.disabled = true;
          submitEl.textContent = 'Selector no disponible';
        }
        return;
      }

      cardsEl.innerHTML = model.pieces.map(function (piece) {
       var selected = state[piece.key];
var isSelected = selected && selected.selected;
var displaySelected = selected;
var benefits =
  PIECE_COPY[piece.key] &&
  Array.isArray(PIECE_COPY[piece.key].benefits)
    ? PIECE_COPY[piece.key].benefits
    : [];
        var priceInfo = getCardPrice(piece, isSelected ? displaySelected : null);
        var availableForBase = !!getCardPrice(piece, null);
        var availableQuantities = isSelected ? getAvailableQuantities(piece, selected.color, selected.size) : [];
        var sizeOptions = isSelected ? getAvailableSizes(piece, selected.color) : [];
        var minusDisabled = false;
        var plusDisabled = false;

        if (isSelected) {
          if (model.mode === 'unit') {
            minusDisabled = selected.qty <= 1;
          } else {
            var qtyIndex = availableQuantities.indexOf(selected.qty);
            minusDisabled = qtyIndex <= 0;
            plusDisabled = qtyIndex === -1 || qtyIndex >= availableQuantities.length - 1;
          }
        }

        var controlsHtml = '';

        if (isSelected) {
          controlsHtml += '<div class="td-funda-builder__controls">';
          controlsHtml += '<div class="td-funda-builder__control-row">';
         

          if (sizeOptions.length > 1) {
            controlsHtml += '<label class="td-funda-builder__select-label">Talla <select data-td-funda-card-size>' + renderSelectOptions(sizeOptions, selected.size) + '</select></label>';
          }

          controlsHtml += '<span class="td-funda-builder__select-label">Cantidad</span>';
          controlsHtml += '<div class="td-funda-builder__qty" aria-label="Cantidad">';
          controlsHtml += '<button type="button" class="td-funda-builder__qty-button" data-td-funda-minus ' + (minusDisabled ? 'disabled' : '') + ' aria-label="Restar funda">−</button>';
          controlsHtml += '<span class="td-funda-builder__qty-value">' + escapeHtml(selected.qty) + '</span>';
          controlsHtml += '<button type="button" class="td-funda-builder__qty-button" data-td-funda-plus ' + (plusDisabled ? 'disabled' : '') + ' aria-label="Sumar funda">+</button>';
          controlsHtml += '</div>';
          controlsHtml += '<button type="button" class="td-funda-builder__remove" data-td-funda-remove>Quitar</button>';
          controlsHtml += '</div>';

       

          controlsHtml += '</div>';
        }

        return '' +
          '<article class="td-funda-builder__card ' + (isSelected ? 'is-selected' : '') + '" data-td-funda-piece="' + escapeHtml(piece.key) + '">' +
            '<div class="td-funda-builder__icon-wrap">' + getPieceIcon(piece.key) + '</div>' +
            '<div class="td-funda-builder__copy">' +
              '<h4 class="td-funda-builder__card-title">' + escapeHtml(piece.title) + '</h4>' +
              renderPrice(priceInfo) +
              (isSelected ? controlsHtml : '<p class="td-funda-builder__help">' + escapeHtml(piece.help) + '</p>') +
            '</div>' +
         '<div class="td-funda-builder__action">' +
  (isSelected
    ? '<span class="td-funda-builder__added">✓ Agregada</span>'
    : '<button type="button" class="td-funda-builder__add" data-td-funda-add ' + (availableForBase ? '' : 'disabled') + '>+ Agregar</button>') +
'</div>' +
(
  isSelected
    ? renderBenefits(benefits)
    : ''
) +
'</article>';
      }).join('');
    }

    function renderSubmit() {
      if (!submitEl || !model.valid) return;

      var result = selectedLines();

      if (result.error) {
        submitEl.disabled = true;
        submitEl.textContent = 'Revisa disponibilidad';
        setMessage(result.error, 'error');
        return;
      }

      setMessage('');

      if (!result.lines.length) {
        submitEl.disabled = true;
        submitEl.textContent = 'Selecciona fundas';
        return;
      }

      var units = result.lines.reduce(function (sum, line) {
        return sum + line.units;
      }, 0);
      var total = result.lines.reduce(function (sum, line) {
        return sum + line.linePrice;
      }, 0);

      submitEl.disabled = false;
      submitEl.textContent = 'Agregar selección (' + units + ') • ' + money(total, model.currency);
    }

    function render() {
      renderColors();
      renderCards();
      renderSubmit();
    }

    function getPieceByKey(pieceKey) {
      return model.pieces.find(function (piece) {
        return piece.key === pieceKey;
      });
    }

    function selectPiece(pieceKey) {
      var piece = getPieceByKey(pieceKey);
      if (!piece) return;

      var color = getBestColorForPiece(piece, defaultColor);
      var size = getDefaultSize(piece, color);
      var qty = getInitialQty(piece, color, size);

      state[pieceKey] = {
        selected: true,
        color: color,
        size: size,
        qty: qty
      };

      render();
    }

    function stepQuantity(pieceKey, direction) {
      var piece = getPieceByKey(pieceKey);
      var selected = state[pieceKey];
      if (!piece || !selected) return;

      if (model.mode === 'unit') {
        selected.qty = Math.max(1, selected.qty + direction);
        render();
        return;
      }

      var availableQuantities = getAvailableQuantities(piece, selected.color, selected.size);
      var index = availableQuantities.indexOf(selected.qty);
      if (index === -1) index = 0;

      var nextIndex = Math.max(0, Math.min(availableQuantities.length - 1, index + direction));
      if (availableQuantities[nextIndex]) selected.qty = availableQuantities[nextIndex];
      render();
    }

function applyBaseColor(color) {
  defaultColor = color;

  model.pieces.forEach(function (piece) {
    var selected = state[piece.key];

    if (!selected || !selected.selected) return;

    selected.color = color;

    var sizes = getAvailableSizes(piece, color);

    if (
      model.sizeIndex > -1 &&
      sizes.indexOf(selected.size) === -1
    ) {
      selected.size = sizes.length ? sizes[0] : '';
    }

    if (model.mode === 'pack') {
      var quantities = getAvailableQuantities(
        piece,
        color,
        selected.size
      );

      if (
        quantities.length &&
        quantities.indexOf(selected.qty) === -1
      ) {
        selected.qty = quantities[0];
      }
    }
  });

  render();
}

    function syncAfterSizeChange(pieceKey, size) {
      var piece = getPieceByKey(pieceKey);
      var selected = state[pieceKey];
      if (!piece || !selected) return;

      selected.size = size;

      var quantities = getAvailableQuantities(piece, selected.color, size);
      if (model.mode === 'pack' && quantities.length && quantities.indexOf(selected.qty) === -1) {
        selected.qty = quantities[0];
      }

      render();
    }

    function getCartUi() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function getSectionsToRender(cart) {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        try {
          return cart.getSectionsToRender().map(function (section) {
            return section.id;
          });
        } catch (error) {}
      }

      return ['cart-drawer', 'cart-icon-bubble'];
    }

    function renderCart(response, cart) {
      var routes = getRoutes();

      if (cart && response && response.sections && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        var drawerInner = cart.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.remove('is-empty');
        cart.renderContents(response);
        return;
      }

      window.location.href = routes.cart_url || '/cart';
    }

    function track(lines) {
      var payload = {
        event: 'td_funda_builder_added',
        product_id: config.productId,
        product_handle: config.productHandle,
        builder_mode: model.mode,
        units: lines.reduce(function (sum, line) { return sum + line.units; }, 0),
        value: lines.reduce(function (sum, line) { return sum + line.linePrice; }, 0) / 100,
        currency: model.currency,
        pieces: lines.map(function (line) {
          return {
            piece: line.piece.title,
            color: line.selected.color,
            units: line.units,
            variant_id: line.variant.id
          };
        })
      };

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(payload);
      }

      document.dispatchEvent(new CustomEvent('td:funda-builder:added', {
        bubbles: true,
        detail: payload
      }));
    }

    function setLoading(loading) {
      if (!submitEl) return;
      submitEl.classList.toggle('is-loading', loading);
      submitEl.disabled = loading;
      if (loading) submitEl.textContent = 'Agregando...';
    }

    function addSelectionToCart() {
      var result = selectedLines();
      var routes = getRoutes();
      var cart = getCartUi();

      if (result.error) {
        setMessage(result.error, 'error');
        return;
      }

      if (!result.lines || !result.lines.length) return;

      var payload = {
        items: result.lines.map(function (line) { return line.item; }),
        sections: getSectionsToRender(cart),
        sections_url: window.location.pathname
      };

      if (cart && typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }

      setLoading(true);
      setMessage('');

      fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok || json.status) throw json;
            return json;
          });
        })
        .then(function (response) {
          track(result.lines);
          renderCart(response, cart);
        })
        .catch(function (error) {
          console.error('[TD Funda Builder]', error);
          var message = error && (error.description || error.message)
            ? (error.description || error.message)
            : 'No pudimos agregar tu selección. Inténtalo nuevamente.';
          setMessage(message, 'error');
        })
        .finally(function () {
          setLoading(false);
          renderSubmit();
        });
    }



    root.addEventListener('click', function (event) {
    var baseColorButton = event.target.closest('[data-td-funda-base-color]');

if (baseColorButton) {
  applyBaseColor(
    baseColorButton.getAttribute('data-td-funda-base-color')
  );
  return;
}


      if (event.target.closest('[data-td-funda-submit]')) {
        event.preventDefault();
        addSelectionToCart();
        return;
      }

      var card = event.target.closest('[data-td-funda-piece]');
      if (!card) return;

      var pieceKey = card.getAttribute('data-td-funda-piece');

      if (event.target.closest('[data-td-funda-add]')) {
        selectPiece(pieceKey);
        return;
      }

      if (event.target.closest('[data-td-funda-remove]')) {
        delete state[pieceKey];
        render();
        return;
      }

      if (event.target.closest('[data-td-funda-plus]')) {
        stepQuantity(pieceKey, 1);
        return;
      }

      if (event.target.closest('[data-td-funda-minus]')) {
        stepQuantity(pieceKey, -1);
      }
    });

    root.addEventListener('change', function (event) {
      var card = event.target.closest('[data-td-funda-piece]');
      if (!card) return;

      var pieceKey = card.getAttribute('data-td-funda-piece');

  

      if (event.target.matches('[data-td-funda-card-size]')) {
        syncAfterSizeChange(pieceKey, event.target.value);
      }
    });

    render();
  }

  function initOne(root) {
    if (!root || root.dataset.tdFundaBuilderMounted === 'true') return;

    var configScript = root.querySelector(CONFIG_SELECTOR);
    if (!configScript) return;

    var config;
    try {
      config = JSON.parse(configScript.textContent);
    } catch (error) {
      console.error('[TD Funda Builder] Config inválida', error);
      return;
    }

    root.dataset.tdFundaBuilderMounted = 'true';
    makeBuilder(root, config);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();